<template>
	<div class="inputFieldContainer flex">
		<div>
			<input
				:id="id"
				type="checkbox"
				:placeholder="placeholder"
				v-model="value"
				class="cursor-pointer"
				@change="changed" />
		</div>
		<label
			:for="id"
			class="text-sm ml-2 cursor-pointer"
			:class="labelColor"
			>{{ label }}
		</label>
	</div>
</template>

<script setup>
	const { id, initialValue } = defineProps({
		id: {
			type: String,
			default: "inputField",
		},
		label: {
			type: String,
			default: "Field Label",
		},
		labelColor: {
			type: String,
			default: "text-primary",
		},
		placeholder: {
			type: String,
			default: "",
		},
		required: {
			type: Boolean,
			default: false,
		},
		initialValue: {
			type: Boolean,
			default: false,
		},
	})

	const emits = defineEmits(["changed"])
	const value = ref(initialValue)
	const changed = () => {
		emits("changed", { id: id, value: value.value })
	}
</script>

<style scoped>
	input[type="checkbox"] {
		/* Add if not using autoprefixer */
		-webkit-appearance: none;
		/* Remove most all native input styles */
		appearance: none;
		/* Not removed via appearance */
		margin-top: 1px;

		@apply bg-white checked:bg-secondary border border-2 border-white checked:border-secondary rounded grid w-5 h-5;
		transform: translateY(-0.075em);
		place-content: center;
	}

	input[type="checkbox"]::before {
		content: "";
		width: 0.65em;
		height: 0.65em;
		clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
		transform: scale(0);
		transform-origin: bottom left;
		transition: 120ms transform ease-in-out;
		box-shadow: inset 1em 1em;
		@apply text-white;
	}

	input[type="checkbox"]:checked::before {
		transform: scale(1);
	}
</style>
